var a={};export{a as default};
//# sourceMappingURL=Provider.js.map
